import createCustomElementWrapper from './utils/createCustomElementWrapper';
export var KatBreadcrumbItem = createCustomElementWrapper('kat-breadcrumb-item', 'KatBreadcrumbItem', {
    'label': 'label',
    'href': 'href',
}, {});
